import React from 'react';
import { PieChart, Pie, Cell } from 'recharts';
import { renderCustomizedLabel, assignColor } from '.';

const LabelledChart = ({
  data,
  chartId,
  label,
  noLabel = false,
  dataKey = 'frequency',
  nameKey = 'category',
  inverseLikert = false,
  height = 500,
  width = 500,
  innerRadius = 70,
  outerRadius = 200,
  hide = false,
}) => {
  return (
    <div style={{ visibility: hide ? 'hidden' : 'visible' }}>
      {!noLabel && (
        <h3 className='fw-bolder text-primary text-center pt-3 pb-3 h5'>
          {label}
        </h3>
      )}
      <PieChart
        width={width}
        height={height}
        id={chartId}
      >
        <Pie
          data={data}
          labelLine={false}
          label={renderCustomizedLabel}
          cx='50%'
          cy='50%'
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          fill='#180040'
          dataKey={dataKey}
          nameKey={nameKey}
        >
          {data.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={assignColor(entry.category, index, inverseLikert)}
            />
          ))}
        </Pie>
      </PieChart>
    </div>
  );
};

export default LabelledChart;
